<template>
  <section class="toggle-switch">
    <span class="label">
      <span v-if="value">{{ labelOn }}</span>
      <span v-else>{{ labelOff }}</span>
    </span>

    <input
      type="checkbox"
      ref="checkbox"
      v-model="localValue"
    />

    <span class="toggle" @click.prevent.stop="toggle">
      <span class="dot" />
    </span>
  </section>
</template>

<script>
export default {
  name: 'Toggle',

  props: {
    value: Boolean,
    labelOn: String,
    labelOff: String,
  },

  data() {
    return {
      localValue: this.value,
    };
  },

  watch: {
    value(value) {
      this.localValue = value;
    },
  },

  methods: {
    toggle() {
      this.localValue = !this.localValue;
      this.$emit('input', this.localValue);
    },
  },
};
</script>

<style lang="scss" rel="stylesheet/scss" scoped>
  input {
    display:none;

    &:checked + .toggle {
      background-color: $success-color;
      border-color: $success-color;
    }

    &:checked + .toggle .dot {
      transform: translate3d(20px, 0px, 0px);
    }
  }

  .label {
    margin-right: $gp / 2;
  }

  .toggle-switch {
    @include prevent-select;
    display: inline-flex;
    align-items: center;
    flex-direction: row;
    width: auto;
  }

  .toggle {
    @include transition(background-color, border-color);
    margin: 0;
    display: inline-block;
    position: relative;
    width: px-to-rem(40px);
    height: px-to-rem(20px);
    border: 1px solid $gray-color;
    outline: none;
    border-radius: px-to-rem(10px);
    background-color: $gray-color;
    cursor: pointer;
    vertical-align: middle;
  }

  .dot {
    @include transition(transform);

    position: absolute;
    border-radius: 100%;
    height: px-to-rem(16px);
    width: px-to-rem(16px);
    left: 1px;
    top: 1px;
    background-color: $white-color;
  }
</style>
